import { ACTIVE_CURRENCY, queryClient } from '@/utils'
import { useNavigate, useParams } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { useAppStore } from '@/store'
import { IUser } from '@/interface'
import { useEffect, useState } from 'react'
import { MerchantService } from '@/api/merchant'
import { tokenSymbolMap } from '@/constants'
import { parseUnits } from 'ethers'
import PayemntStatus from './payment_status'
import { ArrowLeft } from 'lucide-react'

const AcceptPaymentByQR = () => {
  const [order, setOrder] = useState<any>({})
  const { amount } = useParams()
  const { wallet } = useAppStore((state) => state) as any
  const user = queryClient.getQueryData(['user']) as IUser
  const initiateQrPayment = useMutation(async () => {
    const value = Number(amount) / ACTIVE_CURRENCY.conversion_rate
    const data = {
      amount: value,
      receiverAddress: wallet.address,
      destinationChain: user.default_chain,
      orderType: 'qr',
      minAmountOut: parseUnits(value.toFixed(5), tokenSymbolMap[`${user.default_chain}-USDC`].decimals).toString(),
    }
    let qr = await MerchantService.GetDataToSign(data as any)
    setOrder(qr.result)
  })
  useEffect(() => {
    if (!wallet?.address) return
    initiateQrPayment.mutate()
  }, [wallet?.address])
  const navigation = useNavigate()
  const cancelTx = () => navigation('/dashboard/')
  return (
    <div className="absolute bg-white z-10 top-0 left-0 w-full h-full flex flex-col items-center">
      <button onClick={cancelTx} className="absolute left-4 top-4 p-2 hover:bg-black/10 rounded-full active:hover:bg-black/20">
        <ArrowLeft className=" text-black" />
      </button>
      {/* <div className="absolute w-[900px] h-[900px] rounded-full bottom-1/2 bg-primary/80 z-[-1]"></div> */}
      <svg className="absolute h-[500px] z-[-1]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#FEF3ED"
          fill-opacity="1"
          d="M0,96L60,117.3C120,139,240,181,360,202.7C480,224,600,224,720,192C840,160,960,96,1080,69.3C1200,43,1320,53,1380,58.7L1440,64L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
        ></path>
      </svg>
      <PayemntStatus order={order} />

      {/* <img src="/cray-logo.png" className="absolute bottom-0 w-16" /> */}
    </div>
  )
}
export default AcceptPaymentByQR
